<template>
  <v-container v-if="itemToUpdate">
    <v-row>
      <v-col cols="12">
        <v-btn text @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
      <v-col v-bind="cardFormColsProps">
        <v-card v-bind="cardProps" color="primary" class="ui-module-card ui-module-fade-in-up">
          <v-card-title v-bind="cardTitleProps" class="ui-module-titlebar">Editar item</v-card-title>
          <v-card-text>
            <v-form v-model="editarItemForm">
              <v-select
                class="ui-form-field mt-2"
                background-color="transparent"
                color="secondary"
                rounded
                filled
                dense
                :items="tiposItem"
                item-value="id"
                item-text="title"
                v-model="itemToUpdate.fk_idCatTipoItem"
                :rules="required"
              >
                <template v-slot:label>Tipo de item <span class="red--text">*</span> </template>
              </v-select>
              <v-text-field
                class="ui-form-field"
                v-model="itemToUpdate.item"
                v-bind="textInputProps"
                background-color="transparent"
                :rules="required"
              >
                <template v-slot:label>Nombre del item <span class="red--text">*</span> </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions v-bind="cardActionsProps" class="ui-module-actions">
            <v-btn v-bind="secondaryButtonProps" class="ui-module-btn-outline" to="/equipamiento/items">Cancelar</v-btn>
            <v-btn
              v-bind="primaryButtonProps"
              class="ui-module-btn-solid"
              :disabled="!editarItemForm || loading"
              v-on:click="triggerUpdateItem()"
              >Editar item</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  cardActionsProps,
  cardFormColsProps,
  cardProps,
  cardTitleProps,
  primaryButtonProps,
  secondaryButtonProps,
  textInputProps,
} from '../../components/props/props'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_ITEM_TO_UPDATE(this.id)
  },

  data() {
    return {
      cardFormColsProps,
      cardProps,
      cardTitleProps,
      cardActionsProps,
      primaryButtonProps,
      secondaryButtonProps,
      textInputProps,

      loading: false,
      editarItemForm: false,

      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('tipoItem', {
      tiposItem: 'getTiposItem',
    }),

    ...mapGetters('item', {
      itemToUpdate: 'getItemToUpdate',
    }),
  },

  methods: {
    ...mapActions('item', ['updateItem']),
    ...mapMutations('item', ['SET_ITEM_TO_UPDATE']),
    ...mapActions('tipoItem', ['fetchTiposItem']),

    triggerUpdateItem: async function () {
      this.loading = true

      await this.updateItem(this.itemToUpdate)
      await this.fetchTiposItem()

      this.$router.replace('/equipamiento/items')
      this.loading = false
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
  font-weight: 500;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #ffbe76 !important;
  font-weight: 600;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-outline {
  background: rgba(255, 159, 67, 0.08) !important;
  border: 1px solid rgba(255, 159, 67, 0.35) !important;
  color: #ffbe76 !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.25) !important;
}

.red--text {
  color: #ff5252 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}
</style>
